<template>
    <div class="main">
        <div class="btns">
            <div v-if="searchValIsHide" class="leftSearch">
                <div>
                    <a-button
                        type="primary"
                        @click="addNursingPopup = true"
                        style="margin-right: 20px"
                        >添加账号</a-button
                    >
                    <a-input-search
                        placeholder="请输入姓名或手机号"
                        style="width: 240px"
                        v-model="searchVal"
                        @search="onSearch"
                    />
                </div>
                <p>
                    共 <span>{{ num1 }}</span> 位院长
                    <span>{{ num2 }}</span> 位管理员
                </p>
            </div>
            <div v-else>
                <span
                    >关于“{{ searchVal }}”共搜索到<span style="color: #1890ff">
                        {{ total }} </span
                    >条结果</span
                >
                <span
                    @click="backBtn"
                    style="color: #1890ff; cursor: pointer; margin-left: 20px"
                    >返回</span
                >
            </div>
        </div>
        <div v-if="total != 0">
            <a-table
                :columns="columns"
                :data-source="tableData"
                bordered
                :pagination="false"
                rowKey="userId"
            >
                <template slot="beds" slot-scope="scope">
                    <div class="addBed">
                        <div class="bedChoice" v-if="scope.deanBedList">
                            <div
                                class="bedItem"
                                v-for="(item, index) in scope.deanBedList"
                                :key="index"
                            >
                                <span>{{ item.name }}</span
                                ><a-icon
                                    type="close-circle"
                                    theme="filled"
                                    class="close"
                                    @click="delBed(item.id, scope.userId)"
                                />
                            </div>
                            <div
                                class="addBtn"
                                v-if="scope.roleId == 2"
                                @click="addBedClick(scope)"
                            >
                                <a-icon
                                    type="plus-circle"
                                    theme="filled"
                                    class="iconBtn"
                                />添加床位
                            </div>
                        </div>
                        <div
                            class="addBtn"
                            v-if="!scope.deanBedList && scope.roleId == 2"
                            @click="addBedClick(scope)"
                        >
                            <a-icon
                                type="plus-circle"
                                theme="filled"
                                class="iconBtn"
                            />添加床位
                        </div>
                    </div>
                </template>
                <template slot="operation" slot-scope="scope">
                    <div class="operation">
                        <a-icon
                            type="form"
                            class="tableIcon"
                            @click="edit(scope)"
                        />
                        <img
                            src="../../assets/icon_trashCan_nor.png"
                            class="tableImg"
                            v-if="scope.noDelete != 1"
                            @click="deleteAccount(scope)"
                        />
                    </div>
                </template>
            </a-table>
        </div>
        <a-empty v-else />
        <a-pagination
            v-model="pageNum"
            @change="pageChange"
            :total="total"
            :pageSize="20"
            :hideOnSinglePage="true"
            show-less-items
            style="text-align: center; margin-top: 20px"
        />
        <!-- 添加 -->
        <a-modal
            title="添加账号"
            :visible="addNursingPopup"
            :maskClosable="false"
            okText="添加"
            :width="400"
            @cancel="addNursingOff"
            :footer="null"
        >
            <a-form>
                <a-form-item label="">
                    <div
                        class="login_input"
                        :style="{ borderColor: nameColor }"
                    >
                        <input
                            type="text"
                            maxlength="18"
                            v-model="addListData.name"
                            placeholder="请输入姓名"
                        />
                        <a-icon
                            type="info-circle"
                            theme="filled"
                            style="color: #ff4d4f"
                            v-if="nameIcon"
                        />
                    </div>
                    <p class="tips" :style="{ color: nameColor }">
                        {{ nameTips }}
                    </p>
                </a-form-item>
                <a-form-item label="">
                    <div
                        class="login_input"
                        :style="{ borderColor: phoneColor }"
                    >
                        <input
                            type="text"
                            autocomplete="off"
                            maxlength="11"
                            v-model="addListData.phone"
                            placeholder="请输入手机号"
                        />
                        <a-icon
                            type="info-circle"
                            theme="filled"
                            style="color: #ff4d4f"
                            v-if="phoneIcon"
                        />
                    </div>
                    <p
                        class="tips"
                        :style="{ color: phoneColor }"
                        v-if="phoneIcon"
                    >
                        {{ phoneTips }}
                    </p>
                </a-form-item>
                <a-form-item label="">
                    <div
                        class="login_input"
                        :style="{ borderColor: passwordColor }"
                    >
                        <input
                            type="text"
                            placeholder="请输入密码"
                            autocomplete="off"
                            v-model="addListData.password"
                        />
                        <a-icon
                            type="info-circle"
                            theme="filled"
                            style="color: #ff4d4f"
                            v-if="passwordIcon"
                        />
                    </div>
                    <p
                        class="tips"
                        :style="{ color: passwordColor }"
                        v-if="passwordIcon"
                    >
                        密码不可为空
                    </p>
                </a-form-item>
                <div class="select">
                    <a-select
                        placeholder="请选择账户类型"
                        v-model="addListData.selectVal"
                        style="width: 240px"
                    >
                        <a-select-option
                            v-for="item in roleList"
                            :key="item.val"
                            :value="item.val"
                            >{{ item.title }}</a-select-option
                        >
                    </a-select>
                    <div class="selectTips" v-if="selectType">
                        请选择账户类型
                    </div>
                </div>
                <a-form-item
                    style="
                        margin-top: 40px;
                        text-align: right;
                        margin-bottom: 0;
                    "
                >
                    <a-button style="margin-right: 10px" @click="addNursingOff"
                        >取消</a-button
                    >
                    <a-button
                        type="primary"
                        @click="addNursingOk"
                        :loading="loading"
                        >添加</a-button
                    >
                </a-form-item>
            </a-form>
        </a-modal>
        <!-- 修改 -->
        <a-modal
            title="修改账号"
            :visible="editNursingPopup"
            :maskClosable="false"
            :width="400"
            @cancel="editNursingOff"
            :footer="null"
        >
            <a-form>
                <a-form-item label="">
                    <div
                        class="login_input"
                        :style="{ borderColor: nameColor }"
                    >
                        <input
                            type="text"
                            maxlength="18"
                            v-model="detailsData.name"
                            placeholder="请输入姓名"
                        />
                        <a-icon
                            type="info-circle"
                            theme="filled"
                            style="color: #ff4d4f"
                            v-if="nameIcon"
                        />
                    </div>
                    <p class="tips" :style="{ color: nameColor }">
                        {{ nameTips }}
                    </p>
                </a-form-item>
                <a-form-item label="">
                    <div
                        class="login_input"
                        :style="{ borderColor: phoneColor }"
                    >
                        <input
                            type="text"
                            maxlength="11"
                            autocomplete="off"
                            v-model="detailsData.mobile"
                            placeholder="请输入手机号"
                        />
                        <a-icon
                            type="info-circle"
                            theme="filled"
                            style="color: #ff4d4f"
                            v-if="phoneIcon"
                        />
                    </div>
                    <p
                        class="tips"
                        :style="{ color: phoneColor }"
                        v-if="phoneIcon"
                    >
                        {{ phoneTips }}
                    </p>
                </a-form-item>
                <a-form-item label="">
                    <div
                        class="login_input"
                        :style="{ borderColor: passwordColor }"
                    >
                        <input
                            type="text"
                            placeholder="请输入密码"
                            autocomplete="off"
                            v-model="detailsData.password"
                        />
                        <a-icon
                            type="info-circle"
                            theme="filled"
                            style="color: #ff4d4f"
                            v-if="passwordIcon"
                        />
                    </div>
                    <p
                        class="tips"
                        :style="{ color: passwordColor }"
                        v-if="passwordIcon"
                    >
                        密码不可为空
                    </p>
                </a-form-item>
                <div class="select">
                    <a-select
                        placeholder="请选择账户类型"
                        v-model="detailsData.roleId"
                        style="width: 240px"
                        :disabled="detailsData.noDelete == 1 ? true : false"
                    >
                        <a-select-option
                            v-for="item in roleList"
                            :key="item.val"
                            :value="item.val"
                            >{{ item.title }}</a-select-option
                        >
                    </a-select>
                    <div class="selectTips" v-if="selectType">
                        请选择账户类型
                    </div>
                </div>
                <a-form-item
                    style="
                        margin-top: 40px;
                        text-align: right;
                        margin-bottom: 0;
                    "
                >
                    <a-button style="margin-right: 10px" @click="editNursingOff"
                        >取消</a-button
                    >
                    <a-button
                        type="primary"
                        @click="editNursingOk"
                        :loading="loading"
                        >确定</a-button
                    >
                </a-form-item>
            </a-form>
        </a-modal>
        <!-- 删除弹窗 -->
        <a-modal
            title=""
            :width="200"
            :visible="delNursingPopup"
            :footer="null"
            :closable="false"
        >
            <p class="delTips">
                <a-icon type="exclamation-circle" />你确定要删除吗？
            </p>
            <div class="delBtn">
                <a-button style="margin-right: 10px" @click="delNursingCancel"
                    >取消</a-button
                >
                <a-button
                    type="primary"
                    @click="delNursingOk"
                    :loading="loading"
                    >确定</a-button
                >
            </div>
        </a-modal>
        <!-- 绑定床位 -->
        <a-modal
            title="添加床位"
            :visible="addBedPopup"
            :maskClosable="false"
            width="960px"
            @cancel="addBedOff"
            :footer="null"
            class="bedModel"
        >
            <a-tree-select
                v-if="treeDatas.length > 0"
                v-model="value"
                style="width: 50%"
                :tree-data="treeDatas"
                tree-checkable
                :treeDefaultExpandAll="true"
                :replace-fields="{ value2: 'value', value: 'id' }"
                :show-checked-strategy="treeStrategy"
                placeholder="请点击选择想要添加的床位"
                :dropdown-style="{ maxHeight: '450px', overflow: 'auto' }"
                @change='onSelect'
            />
            <!-- <a-switch
                checked-children="自动关联"
                un-checked-children="仅选床位"
                default-checked
                style="margin-left: 20px"
                @change="switchChange"
            /> -->
            <!-- <a-radio-group
                default-value="true"
                @change="radioChange"
                size="small"
                button-style="solid"
                style="margin-left: 20px"
            >
                <a-radio-button value="true"> 自动关联 </a-radio-button>
                <a-radio-button value="false"> 仅选床位 </a-radio-button>
            </a-radio-group>

            <a-tree
                v-if="treeDatas.length > 0"
                v-model="checkedKeys"
                checkable
                
                @check="treeCheck"
                :defaultExpandAll="true"
                :autoExpandParent="true"
                :tree-data="treeDatas"
                style="margin-top: 14px"
            /> -->

            <!-- <a-transfer
                class="tree-transfer"
                :data-source="dataSource"
                :target-keys="targetKeys"
                :render="(item) => item.title"
                :show-select-all="false"
                @change="onChange"
            >
                <template
                    slot="children"
                    slot-scope="{
                        props: { direction, selectedKeys },
                        on: { itemSelect },
                    }"
                >
                    <a-tree
                        v-if="direction === 'left'"
                        blockNode
                        checkable
                        checkStrictly
                        defaultExpandAll
                        :checkedKeys="[...selectedKeys, ...targetKeys]"
                        :treeData="treeDatas"
                        @check="
                            (_, props) => {
                                onChecked(
                                    _,
                                    props,
                                    [...selectedKeys, ...targetKeys],
                                    itemSelect
                                );
                            }
                        "
                        @select="
                            (_, props) => {
                                onChecked(
                                    _,
                                    props,
                                    [...selectedKeys, ...targetKeys],
                                    itemSelect
                                );
                            }
                        "
                    />
                </template>
            </a-transfer> -->
            <div class="delBtn delBtnAdd">
                <a-button style="margin-right: 10px" @click="addBedOff"
                    >取消</a-button
                >
                <a-button type="primary" @click="addBedOk" :loading="loading"
                    >添加</a-button
                >
            </div>
        </a-modal>
    </div>
</template>

<script>
const columns = [
    {
        title: "姓名",
        dataIndex: "name",
        width: "7%",
        align: "center",
    },
    {
        title: "手机号",
        dataIndex: "mobile",
        width: "12%",
        align: "center",
    },
    // {
    //     title: "密码",
    //     dataIndex: "password",
    //     width: "7%",
    //     align: "center",
    // },
    {
        title: "账号类别",
        dataIndex: "roleName",
        width: "8%",
        align: "center",
    },
    {
        title: "管理床位范围",
        width: "62%",
        align: "center",
        scopedSlots: { customRender: "beds" },
    },
    {
        title: "操作",
        width: "10%",
        align: "center",
        scopedSlots: { customRender: "operation" },
    },
];
import { TreeSelect } from "ant-design-vue";
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const SHOW_ALL = TreeSelect.SHOW_ALL;
const SHOW_CHILD = TreeSelect.SHOW_CHILD;

function isChecked(selectedKeys, eventKey) {
    return selectedKeys.indexOf(eventKey) !== -1;
}

function handleTreeData(data, targetKeys = []) {
    data.forEach((item) => {
        item["disabled"] = targetKeys.includes(item.key);
        if (item.children) {
            handleTreeData(item.children, targetKeys);
        }
    });
    return data;
}
export default {
    data() {
        return {
            valueBak:[],
            value: [],
            treeStrategy: SHOW_PARENT,
            tableData: [], // 表格数据
            columns,
            addListData: {
                name: "", // 姓名
                phone: "", // 手机号
                password: "", // 密码
                selectVal: undefined, // 账号类型
            },
            roleList: [
                { title: "管理员", val: "1" },
                { title: "院长", val: "2" },
            ],
            addNursingPopup: false, // 新增弹窗
            editNursingPopup: false, // 修改弹窗
            delNursingPopup: false, // 删除弹窗
            loading: false, // 添加人员账号确定loading
            nameTips: "姓名只支持字母、数字或汉字，最多可输入18个字符", // 姓名填写提示
            nameColor: "#BFBFBF", // 提示默认字体颜色
            nameIcon: false, // 姓名警告状态
            phoneTips: "", // 手机号填写提示
            phoneColor: "#BFBFBF", // 提示默认字体颜色
            phoneIcon: false, // 手机号警告状态
            passwordColor: "#BFBFBF", // 提示默认字体颜色
            passwordIcon: false, // 密码警告状态
            pageNum: 1,
            pageSize: 20,
            total: 0, // 总页数
            selectType: false, // 账号类型提示
            typeId: "", // 人员id
            detailsData: {}, // 详情数据
            num1: 0, // 院长账号个数
            num2: 0, // 管理员账号个数
            searchVal: "",
            searchValIsHide: true,
            addBedPopup: false,
            targetKeys: [],
            dataSource: [],
            treeDatas: [],
            noDelete: [],
            checkedKeys: [],
        };
    },
    computed: {
        treeData() {
            return handleTreeData(this.treeDatas, this.targetKeys);
        },
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        treeCheck(checkedKeys) {
            console.log("tree", checkedKeys);
        },
        // 获取表格信息
        getTableData() {
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                name: this.searchVal,
            };
            console.log(1);
            this.$get(
                "/api/user",
                param,
                (res) => {
                    if (res.code == 0) {
                        if (res.data.rows) {
                            let num1 = 0;
                            let num2 = 0;
                            for (let i = 0; i < res.data.rows.length; i++) {
                                res.data.rows[i].password = "******";
                                if (res.data.rows[i].roleId == "1") {
                                    num2++;
                                } else {
                                    num1++;
                                }
                            }
                            this.num1 = num1;
                            this.num2 = num2;
                            this.tableData = res.data.rows;
                        } else {
                            this.tableData = [];
                        }
                        this.total = res.data.total;
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (err) => {
                    console.log(err);
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 分页
        pageChange(e) {
            console.log(e);
            this.pageNum = e;
            this.getTableData();
        },
        // 搜索
        onSearch() {
            this.getTableData();
            this.searchValIsHide = false;
        },
        // 搜索返回
        backBtn() {
            this.searchVal = "";
            this.searchValIsHide = true;
            this.getTableData();
        },
        // 添加人员确定
        addNursingOk() {
            let nameReg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
            // 姓名验证
            if (this.addListData.name) {
                if (
                    nameReg.test(this.addListData.name) &&
                    this.addListData.name.length <= 18
                ) {
                    this.nameTips =
                        "姓名只支持字母、数字或汉字，最多可输入18个字符";
                    this.nameColor = "#BFBFBF";
                    this.nameIcon = false;
                } else {
                    this.nameTips =
                        "姓名只支持字母、数字或汉字，最多可输入18个字符";
                    this.nameColor = "#FF4D4F";
                    this.nameIcon = true;
                    return;
                }
            } else {
                this.nameTips = "姓名不可为空";
                this.nameColor = "#FF4D4F";
                this.nameIcon = true;
                return;
            }
            let phoneReg = /^1[3456789]\d{9}$/;
            // 手机号验证
            if (this.addListData.phone) {
                if (phoneReg.test(this.addListData.phone)) {
                    this.phoneColor = "#BFBFBF";
                    this.phoneIcon = false;
                } else {
                    this.phoneTips = "请输入正确的手机号码";
                    this.phoneColor = "#FF4D4F";
                    this.phoneIcon = true;
                    return;
                }
            } else {
                this.phoneTips = "手机号不可为空";
                this.phoneColor = "#FF4D4F";
                this.phoneIcon = true;
                return;
            }
            // 密码验证
            if (this.addListData.password) {
                this.passwordColor = "#BFBFBF";
                this.passwordIcon = false;
            } else {
                this.passwordColor = "#FF4D4F";
                this.passwordIcon = true;
                return;
            }
            // 账号类型
            if (this.addListData.selectVal == undefined) {
                this.selectType = true;
                return;
            } else {
                this.selectType = false;
            }
            let param = {
                name: this.addListData.name, // 姓名
                mobile: this.addListData.phone, // 手机号
                password: this.addListData.password, // 密码
                roleId: this.addListData.selectVal, // 1管理员 2院长 3护工
            };
            this.loading = true;
            this.$post(
                "/api/user",
                param,
                (res) => {
                    if (res.code == 0) {
                        this.$message.success("添加成功");
                        this.addNursingPopup = false;
                        this.getTableData();
                        this.addListData = {
                            name: "", // 姓名
                            phone: "", // 手机号
                            password: "", // 密码
                        };
                        this.nameTips =
                            "姓名只支持字母、数字或汉字，最多可输入18个字符";
                        this.nameColor = "#BFBFBF";
                        this.nameIcon = false;
                        this.phoneColor = "#BFBFBF";
                        this.phoneIcon = false;
                    } else {
                        this.$message.error(res.msg);
                    }
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 添加人员取消
        addNursingOff() {
            this.addNursingPopup = false;
            this.addListData = {
                name: "", // 姓名
                phone: "", // 手机号
                password: "", // 密码
            };
            this.nameTips = "姓名只支持字母、数字或汉字，最多可输入18个字符";
            this.nameColor = "#BFBFBF";
            this.nameIcon = false;
            this.phoneColor = "#BFBFBF";
            this.phoneIcon = false;
        },
        // 修改按钮
        edit(e) {
            this.typeId = e.userId;
            this.editNursingPopup = true;
            this.getDetailsData();
        },
        // 修改人员确定
        editNursingOk() {
            let nameReg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
            // 姓名验证
            if (this.detailsData.name) {
                if (
                    nameReg.test(this.detailsData.name) &&
                    this.detailsData.name.length <= 18
                ) {
                    this.nameTips =
                        "姓名只支持字母、数字或汉字，最多可输入18个字符";
                    this.nameColor = "#BFBFBF";
                    this.nameIcon = false;
                } else {
                    this.nameTips =
                        "姓名只支持字母、数字或汉字，最多可输入18个字符";
                    this.nameColor = "#FF4D4F";
                    this.nameIcon = true;
                    return;
                }
            } else {
                this.nameTips = "姓名不可为空";
                this.nameColor = "#FF4D4F";
                this.nameIcon = true;
                return;
            }
            let phoneReg = /^1[3456789]\d{9}$/;
            // 手机号验证
            if (this.detailsData.mobile) {
                if (phoneReg.test(this.detailsData.mobile)) {
                    this.phoneColor = "#BFBFBF";
                    this.phoneIcon = false;
                } else {
                    this.phoneTips = "请输入正确的手机号码";
                    this.phoneColor = "#FF4D4F";
                    this.phoneIcon = true;
                    return;
                }
            } else {
                this.phoneTips = "手机号不可为空";
                this.phoneColor = "#FF4D4F";
                this.phoneIcon = true;
                return;
            }
            
            if (this.detailsData.password!="") {
                this.passwordColor = "#BFBFBF";
                this.passwordIcon = false;
            } else {
                this.passwordColor = "#FF4D4F";
                this.passwordIcon = true;
                return;
            }
            

            let param = {
                name: this.detailsData.name, // 姓名
                mobile: this.detailsData.mobile, // 手机号
                password: this.detailsData.password, // 密码
                roleId: this.detailsData.roleId, // 1管理员 2院长 3护工
                userId: this.typeId,
            };
            this.loading = true;
            this.$put(
                "/api/user",
                param,
                (res) => {
                    if (res.code == 0) {
                        this.$message.success("修改成功");
                        this.getTableData();
                        this.loading = false;
                        this.editNursingPopup = false;
                    } else {
                        this.$message.error(res.msg);
                    }
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    console.log(err);
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 修改人员取消
        editNursingOff() {
            this.editNursingPopup = false;
        },
        // 获取人员详情
        getDetailsData() {
            this.$get(
                "/api/user/" + this.typeId,
                {},
                (res) => {
                    if (res.code == 0) {
                        this.detailsData = JSON.parse(JSON.stringify(res.data));
                        this.detailsData.password = "";
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (err) => {
                    console.log(err);
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 删除账号按钮
        deleteAccount(e) {
            this.typeId = e.userId;
            this.delNursingPopup = true;
            this.noDelete = e.noDelete;
        },
        // 确认删除账号
        delNursingOk() {
            this.loading = true;
            this.$delete(
                "/api/user/" + this.typeId,
                {},
                (res) => {
                    if (res.code == 0) {
                        this.$message.success("删除成功");
                        this.getTableData();
                        this.delNursingPopup = false;
                    } else {
                        this.$message.error(res.msg);
                    }
                    this.loading = false;
                },
                (err) => {
                    console.log(err);
                    this.loading = false;
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 删除取消
        delNursingCancel() {
            this.delNursingPopup = false;
        },
        // 绑定床位弹窗
        addBedClick(scope) {
            this.addBedPopup = true;
            console.log(scope.deanBedList);

            this.typeId = scope;
            this.getBedTreeData();
        },
        // 绑定床位确定
        addBedOk() {
            var newValue = [];
            for(var i=0;i<this.value.length;i++){
                if(this.valueBak.indexOf(this.value[i])<0){
                    newValue.push(this.value[i]);
                }
            }
            let param = {
                objIdList: newValue,
                userId: this.typeId.userId,
            };
            this.loading = true;
            this.$post(
                "/api/dean/bed",
                param,
                (res) => {
                    if (res.code == 0) {
                        this.$message.success("添加成功");
                        this.addBedPopup = false;
                        this.getTableData();
                        this.targetKeys = [];
                        this.value = [];
                    }
                    this.loading = false;
                },
                (err) => {
                    console.log(err);
                    this.loading = false;
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 取消绑定床位
        addBedOff() {
            this.addBedPopup = false;
            this.value = [];
            this.valueBak = [];
        },
        // 删除绑定
        delBed(id, userId) {
            this.$delete(
                "/api/dean/bed/" + id,
                {},
                (res) => {
                    if (res.code == 0) {
                        this.getTableData();
                        this.$message.success("删除成功");
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (err) => {
                    console.log(err);
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 获取床位树形数据
        getBedTreeData() {
            var that = this;
            this.$get(
                "/api/dean/bedTree",
                { userId: this.typeId.userId },
                (res) => {
                    if (res.code == 0) {
                        console.log(res);
                        const transferDataSource = [];
                        function flatten(list = []) {
                            list.forEach((item) => {
                                transferDataSource.push(item);
                                flatten(item.children);
                            });
                        }
                        flatten(JSON.parse(JSON.stringify(res.data.children)));
                        that.dataSource = transferDataSource;
                        that.treeDatas = res.data.children;
                        that.checkBed(that.treeDatas);
                    }
                },
                (err) => {
                    console.log(err);
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        checkBed(list) {
            for (var i = 0; i < list.length; i++) {
                //console.log("##", list[i]);
                if (list[i].disabled && list[i].hasChildren) {
                    this.value.push(list[i].key);
                    this.addDisabled(list[i].children);
                }
                if (list[i].hasChildren) {
                    this.checkBed(list[i].children);
                }
            }

            //console.log("###", this.value);
        },
        addDisabled(list) {
            for (var i = 0; i < list.length; i++) {
                //console.log("##", list[i]);
                list[i].disabled = true;
                this.value.push(list[i].key);
                if (list[i].hasChildren) {
                    //console.log('111',list[i].children)
                    this.addDisabled(list[i].children);
                }
            }
            this.valueBak = JSON.parse(JSON.stringify(this.value));
        },
        flatten(list = []) {
            list.forEach((item) => {
                this.dataSource.push(item);
                flatten(item.children);
            });
        },
        onChange(targetKeys, direction, moveKeys) {
            console.log("Target Keys:", targetKeys, direction, moveKeys);
            this.targetKeys = targetKeys;
        },
        switchChange(checked) {
            console.log(`a-switch to ${checked}`);
            if (checked) {
                this.treeStrategy = SHOW_PARENT;
            } else {
                this.treeStrategy = SHOW_CHILD;
            }
        },
        radioChange(e) {
            console.log(`a-radio to ${e.target.value}`);
            if (e.target.value == "true") {
                this.treeStrategy = SHOW_PARENT;
            } else {
                this.treeStrategy = SHOW_CHILD;
            }
        },
        onChecked(_, e, checkedKeys, itemSelect) {
            const { eventKey } = e.node;
            itemSelect(eventKey, !isChecked(checkedKeys, eventKey));
        },
        onSelect(value, node, extra){
            for(var i=0;i<this.valueBak.length;i++){
                if(this.value.indexOf(this.valueBak[i])<0){
                    this.value.push(this.valueBak[i]);
                }
            }
            //console.log(this.value)

        }
    },
};
</script>

<style lang='scss' scoped>
.main::v-deep {
    padding-top: 0 !important;
    .btns {
        .leftSearch {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        margin-bottom: 10px;
        p {
            margin-bottom: 0;
            span {
                color: #1890ff;
            }
        }
    }
    .ant-table-thead > tr > th {
        background: #f0f0f0;
    }
    .ant-table-tbody {
        min-height: 1134px;
        .ant-table-row:nth-child(even) {
            background: #fafafa;
        }
    }
    .ant-table-row td:nth-child(5) {
        padding-bottom: 6px;
    }
    .ant-table-content {
        min-height: 1134px;
    }
    .ant-table-thead
        > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td,
    .ant-table-tbody
        > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td,
    .ant-table-thead
        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td,
    .ant-table-tbody
        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td {
        background: none;
    }
    .operation {
        display: flex;
        align-items: center;
        justify-content: center;
        .tableIcon {
            color: #1890ff;
            font-size: 20px;
            cursor: pointer;
        }
        .tableImg {
            margin-left: 10px;
            cursor: pointer;
            vertical-align: baseline;
        }
    }
}
.login_input {
    display: flex;
    position: relative;
    width: 100%;
    height: 16px;
    padding-bottom: 13px;
    border-bottom: 1px solid;
    box-sizing: content-box;
    img {
        width: 16px;
        height: 16px;
        margin: 0 22px 0 16px;
    }
    input {
        flex: 1;
        border: 0; // 去除未选中状态边框
        outline: none; // 去除选中状态边框
        background-color: rgba(0, 0, 0, 0) !important;
        padding-right: 46px;
        height: 16px !important;
        line-height: 16px !important;
    }
    input:-webkit-autofill {
        transition: background-color 5000s ease-in-out 0s;
    }
    input::-webkit-input-placeholder {
        color: #bfbfbf;
    }
    input:-moz-placeholder {
        color: #bfbfbf;
    }
    input::-moz-placeholder {
        color: #bfbfbf;
    }
    input:-ms-input-placeholder {
        color: #bfbfbf;
    }
    .cu {
        cursor: pointer;
    }
}
.tips {
    font-size: 14px;
    margin-bottom: 0;
    line-height: 20px;
    // position: absolute;
    width: 486px;
}
.ant-form-item {
    margin-bottom: 40px;
}
.select {
    display: flex;
    .selectTips {
        margin-left: 10px;
        margin-bottom: 0;
        line-height: 30px;
        color: #ff4d4f;
    }
}
.delTips {
    .anticon {
        color: #faad14;
        margin-right: 10px;
    }
}
.delBtn {
    text-align: right;
    margin-top: 20px;
    .ant-btn {
        border-radius: 2px;
        text-align: center;
        font-size: 14px;
    }
}
.delBtnAdd {
    margin-top: 100px;
}
.addBed {
    color: #1890ff;
    display: flex;
    align-items: center;
    .bedChoice {
        display: flex;
        flex-wrap: wrap;
        .bedItem {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 32px;
            line-height: 32px;
            // padding: 6px 12px;
            // width: 160px;
            background: #e6f7ff;
            color: #1890ff;
            margin-bottom: 10px;
            margin-right: 10px;
            padding: 0 12px;
            span {
                flex: 1;
                text-align: left;
                margin-right: 6px;
            }
            .close {
                color: #1890ff;
                cursor: pointer;
            }
        }
        .bedItem:hover {
            background: #bae7ff;
        }
    }
    .addBtn {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding-bottom: 10px;
        .iconBtn {
            margin-right: 6px;
        }
    }
    .addBtn:hover {
        .iconBtn {
            color: #0072db;
        }
        text-decoration: underline;
    }
}

::v-deep.tree-transfer .ant-transfer-list {
    width: 47.7%;
    flex: none;
    .ant-transfer-list-header {
        background: #f0f0f0;
    }
}
</style>